import { ModuleWithProviders, NgModule } from '@angular/core';
import { AccessCodeModule } from '@spaq/modules/access-code';
import { ContractModule } from '@spaq/modules/contract';
import { SubscriptionModule } from '@spaq/modules/subscription';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { SharedFormModule } from '@spaq/shared/shared-form.module';
import {
	RecoverEmailComponent,
	RegisterAccessCodeComponent,
	RegisterContractComponent,
	RegisterContractConfirmDetailsComponent,
	RegisterContractEmailComponent,
	RegisterContractEmailConfirmComponent,
	RegisterContractEmailPendingComponent,
	RegisterEmailComponent,
	RegisterEmailConfirmationComponent,
	RegisterEmailFormComponent,
	RegisterEmailPendingComponent,
	RegisterSubscriptionComponent,
	RegisterTitleComponent
} from './components';
import {
	RegisterAccessCodePageComponent,
	RegisterContractConfirmationPageComponent,
	RegisterContractPageComponent,
	RegisterEmailConfirmationPageComponent,
	RegisterEmailPageComponent,
	RegisterEmailPendingPageComponent,
	RegisterSubscriptionPageComponent
} from './pages';

@NgModule({
	imports: [
		ContractModule,
		SubscriptionModule,
		AccessCodeModule,
		SharedComponentsModule,
		FormModule,
		SharedCommonModule,
		SharedFormModule
	],
	declarations: [
		//  RegisterCodeEmailComponent,
		RegisterEmailComponent,
		RegisterEmailFormComponent,
		RegisterEmailPendingComponent,
		RegisterEmailConfirmationComponent,
		RegisterContractComponent,
		RegisterContractEmailComponent,
		RegisterContractEmailConfirmComponent,
		RegisterContractEmailPendingComponent,
		RegisterContractConfirmDetailsComponent,
		RecoverEmailComponent,
		RegisterAccessCodeComponent,
		RegisterTitleComponent,
		RegisterSubscriptionComponent,

		RegisterAccessCodePageComponent,
		RegisterContractPageComponent,
		RegisterContractConfirmationPageComponent,
		RegisterEmailPageComponent,
		RegisterEmailConfirmationPageComponent,
		RegisterEmailPendingPageComponent,
		RegisterSubscriptionPageComponent
	],
	exports: [
		//  RegisterCodeEmailComponent,
		RegisterEmailComponent,
		RegisterEmailFormComponent,
		RegisterEmailPendingComponent,
		RegisterEmailConfirmationComponent,
		RegisterContractComponent,
		RegisterContractEmailComponent,
		RegisterContractEmailConfirmComponent,
		RegisterContractEmailPendingComponent,
		RegisterContractConfirmDetailsComponent,
		RecoverEmailComponent,
		RegisterAccessCodeComponent,
		RegisterTitleComponent,
		RegisterSubscriptionComponent
	]
})
export class RegisterModule {
	static forRoot(): ModuleWithProviders<RegisterModule> {
		return {
			ngModule: RegisterModule,
			providers: []
		};
	}
}
